import { useState, useEffect } from 'react';
import axios from 'axios';
import NavBar from '../../components/NavBar/NavBar';
import MeasurementCategoriesTable from '../../components/Tables/MeasurementCategoriesTable';
import MeasurementCategoriesForm from '../../components/Forms/MeasurementCategoriesForm';
import { Container } from 'react-bootstrap';

const API_BASE_URL =  process.env.REACT_APP_API_BASE_URL;

const MeasurementCategoriesPage = ({ categories: initialCategories, fetchCategories, auth, onLogout }) => {
	const [categories, setCategories] = useState(initialCategories || []);
	const [editingCategory, setEditingCategory] = useState(null);
	const [showForm, setShowForm] = useState(false);

	// If data passed from App.jsx later, update
	useEffect(() => {
		setCategories(initialCategories || []);
	}, [initialCategories]);

	const addCategory = (newCategory) => {
		setCategories((prev) => [...prev, newCategory]);
		setShowForm(false);
		fetchCategories(); // Fetch updated categories from API
	};

	const updateCategory = (updatedCategory) => {
		setCategories((prev) =>
			prev.map((cat) => (cat.id === updatedCategory.id ? updatedCategory : cat))
		);
		setEditingCategory(null);
		setShowForm(false);
		fetchCategories();
	};

	const deleteCategory = async (id) => {
        try {
			await axios.delete(`${API_BASE_URL}/measurement-categories/${id}`, {
                headers: { Authorization: `Bearer ${auth.token}` } // authorization header
            });
            setCategories((prev) => prev.filter((cat) => cat.id !== id));
            fetchCategories();
        } catch (error) {
            alert('Failed to delete category. Please try again.');

			if (error.response?.status === 401) {
                onLogout(); // Trigger logout on 401 error
            } else {
                alert('Failed to delete category. Please try again.');
            }
        }
    };

	const handleEdit = (category) => {
		setEditingCategory(category);
		setShowForm(true);
	};

	const handleAddNew = () => {
		setEditingCategory(null);
		setShowForm(true);
	};

	return (
		<>
			<NavBar auth={auth} onLogout={onLogout} />
			<Container fluid className="d-flex flex-column justify-content-center align-items-center">
				{showForm && (
					<MeasurementCategoriesForm
						onSubmit={editingCategory ? updateCategory : addCategory}
						initialData={editingCategory}
						onCancel={() => {
							setShowForm(false);
							setEditingCategory(null);
						}}
						auth={auth}
                        onLogout={onLogout}
					/>
				)}
				<MeasurementCategoriesTable
					categories={categories}
					loading={!initialCategories}
					onAddNewCategory={handleAddNew}
					onEdit={handleEdit}
					onDelete={deleteCategory}
				/>
			</Container>
		</>
	);
};

export default MeasurementCategoriesPage;